export default __webpack_public_path__ + "static/media/logo_no_bg.2b3ea5ec.png";